import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIntegralWorks, updateIntegralWorksList } from '@/api/modules/IntegralWorks'

export const getIntegralWorksAction = createAsyncThunk(
    "getIntegralWorks",
    async () => {
        // getUserChannels函数是一个axios的请求
        const result = await getIntegralWorks();
        if (!result.error) return result.data;
        else {
            return Promise.reject(result.error);
        }
    }
)

export const updateIntegralWorksListAction = createAsyncThunk(
    "updateIntegralWorksList",
    async ({ taskId, params }: any) => {
        // getUserChannels函数是一个axios的请求
        const result = await updateIntegralWorksList(taskId, params);
        if (result.data) return result.data;
    }
)
